function throttle(callback, limit) {
	let wait = false,
		refire = false,
		args;

	return function throttled() {
		args = arguments;

		if (wait) {
			refire = true;
		} else {
			callback.apply(this, args);
			wait = true;

			setTimeout(() => {
				wait = false;

				if (refire) {
					refire = false;
					throttled.apply(this, args);
				}
			}, limit);
		}
	};
}

export default throttle;
